import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b0b590c")

_pushScopeId("data-v-5b0b590c")
const _hoisted_1 = { class: "frame" }
const _hoisted_2 = { class: "file-list" }
const _hoisted_3 = { class: "attached-file" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("????????")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ここにファイルを")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("ドラッグ＆ドロップ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("して下さい。")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = {
  ref: "downloadRef",
  href: "#",
  download: "",
  class: "hidden-link"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_button = _resolveComponent("icon-button")
  const _component_file_name_text = _resolveComponent("file-name-text")
  const _component_drop_area = _resolveComponent("drop-area")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, null, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileFileId[_ctx.resultIndex][_ctx.kartePartsIndex], (id, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "file-frame",
              key: id
            }, [
              _createVNode("div", _hoisted_3, [
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_icon_button, {
                      key: 0,
                      icon: "times",
                      state: "delete",
                      onClick: ($event: any) => (_ctx.onDeleteFile(i))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.fileName[_ctx.resultIndex][_ctx.kartePartsIndex][i])
                  ? (_openBlock(), _createBlock(_component_file_name_text, {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onDownloadFile(i))
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.fileName[_ctx.resultIndex][_ctx.kartePartsIndex][i]), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_file_name_text, { key: 2 }, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }))
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock("div", {
          class: "drop-frame",
          key: `drop-frame-${_ctx.resultIndex}-${_ctx.kartePartsIndex}`
        }, [
          _createVNode(_component_drop_area, {
            "file-types": ['.*'],
            onFile: _ctx.onFile
          }, {
            default: _withId(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createTextVNode("(" + _toDisplayString(_ctx.MaxAttachFileMega) + "MByteまで) ", 1)
            ]),
            _: 1
          }, 8, ["file-types", "onFile"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("a", _hoisted_11, null, 512)
  ]))
})